import { render, staticRenderFns } from "./showWordLimit-editor.vue?vue&type=template&id=183cd3e3&scoped=true"
import script from "./showWordLimit-editor.vue?vue&type=script&lang=js"
export * from "./showWordLimit-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183cd3e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('183cd3e3')) {
      api.createRecord('183cd3e3', component.options)
    } else {
      api.reload('183cd3e3', component.options)
    }
    module.hot.accept("./showWordLimit-editor.vue?vue&type=template&id=183cd3e3&scoped=true", function () {
      api.rerender('183cd3e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/showWordLimit-editor.vue"
export default component.exports